import { Controller } from "@hotwired/stimulus";

// Replaces the prices the page was rendered with by PayPro's own for this visitor
export default class extends Controller {
  static values = { url: String }

  async connect() {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: 'application/json' } });
      if (response.status !== 200) return;
      const texts = await response.json();
      this.element.querySelectorAll('[data-price]').forEach((element) => {
        const text = texts[element.dataset.price];
        if (text) element.textContent = text;
      });
    } catch {
      // The page keeps the prices it has
    }
  }
}
